import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {Favorite} from '@models/favorite';
import {User} from '@models/user';
import {EMPTY_USER} from '@models/empty';
import {CityService} from '@services/city.service';
import {AuthenticationService} from '@services/authentification.service';
import {DeviceDetectorService} from 'ngx-device-detector';

@Component({
  selector: 'app-population-activity',
  templateUrl: './population-activity.component.html',
  styleUrls: ['./population-activity.component.scss']
})
export class PopulationActivityComponent implements OnInit {

    @Input() favorite: Favorite;
    @Input() preview: boolean;
    @Output() extChange = new EventEmitter();
    user: User = Object.assign({}, EMPTY_USER);
    tabs = 'country';
    secteur = '';
    iris = '';

    compare = [];
    displayedColumns: string[] = ['lib', 'quartier', 'secteur', 'ville', 'france'];

    options = {
        tooltip: {
            trigger: 'item',
            formatter: '{c} {b} ({d} %)'
        },
        calculable: true,
        legend: {
            show: true,
            top: 'bottom',
            left: 'center',
            data: ['Retraités','Actifs','Inactifs','Chômeurs', 'Étudiants'],
        },
    };

    data = {
        series: []
    };

    constructor(
        public cityService: CityService,
        public deviceService: DeviceDetectorService,
        public authenticationService: AuthenticationService) {
    }


    ngOnInit() {
        if (this.favorite.iris != ''
            && this.favorite.ad_city.mapping_quartier_iris != null
            && this.favorite.ad_city.mapping_quartier_iris.quartier != null) {
            this.tabs = 'quartier';
        }
        this.iris = this.favorite.iris;
        if (this.favorite.ad_city.mapping_quartier_iris && this.favorite.ad_city.mapping_quartier_iris.quartier && this.favorite.ad_city.mapping_quartier_iris.quartier.length == 1) {
            // this.secteur = this.favorite.ad_city.mapping_quartier_iris.quartier[0].GQ_c;
            // this.iris = this.secteur;
            this.displayedColumns = ['lib', 'quartier', 'ville', 'france'];
        }
        if (!this.favorite.ad_city.mapping_quartier_iris || !this.favorite.ad_city.mapping_quartier_iris.quartier) {
            this.displayedColumns = ['lib', 'ville', 'france'];
        }

        this.setData();
        this.extChange.subscribe(data => {
            this.setData();
        });
        this.user = this.authenticationService.currentUser;
    }

    setData() {
        if (this.iris != '') {
            this.secteur = this.iris.substring(0, 7);
        }

        let irisData = null;
        if (this.iris != '' && this.favorite.ad_city.carac_commune_iris && this.favorite.ad_city.carac_commune_iris[this.iris]) {
            irisData = this.favorite.ad_city.carac_commune_iris[this.iris];
        }

        let secteurData = null;
        if (this.secteur != '' && this.favorite.ad_city.carac_commune_gq && this.favorite.ad_city.carac_commune_gq[this.secteur]) {
            secteurData = this.favorite.ad_city.carac_commune_gq[this.secteur];
        }

        let root = this.favorite.ad_city.carac_commune;
        // Donnée absente (ex. payload de partage allégé) -> widget muet, pas de plantage
        if (!root) {
            return;
        }
        if (this.tabs == 'quartier') {
            if (this.secteur == '') {
                // Tout la ville = nothing
            } else if (this.iris.length == 7 && secteurData) {
                root = secteurData;
            } else if (this.iris.length > 7 && irisData) {
                root = irisData;
            }
        }

        const total = root.P75P +
            root.P6074 +
            root.P4559 +
            root.P3044 +
            root.P1529 +
            root.P0014;

        this.data = {
            series: [
                {
                    name: '',
                    type: 'pie',
                    radius: ['0%', '30%'],
                    bottom: '15%',
                    avoidLabelOverlap: false,
                    label: {
                        show: true,
                        position: 'center',
                        color: 'black',
                        fontSize: 20
                    },
                    color: ['#FFFFFF'],

                    data: [
                        {
                            value: Math.round(total),
                            name: (Math.round(total)).toString() + '\nHabitants'
                        },

                    ],
                },
                {
                    name: '',
                    type: 'pie',
                    color: ['#67C2EF', '#79C447', '#FABB3D', '#1277AA', '#FF5455'],
                    radius: ['55%', '81%'],
                    bottom: '15%',
                    label: {
                        show: false,
                        position: 'outer',
                        alignTo: 'labelLine',
                        bleedMargin: 5
                    },
                    data: [
                        {value: Math.round(root.T_retraite * total).toFixed(1), name: 'Retraités'},
                        {value: Math.round(root.T_actif_occ * total).toFixed(1), name: 'Actifs'},
                        {value: Math.round(root.T_autre_inac * total).toFixed(1), name: 'Inactifs'},
                        {value: Math.round(root.T_chom * total).toFixed(1), name: 'Chômeurs'},
                        {value: Math.round(root.T_etud * total).toFixed(1), name: 'Étudiants'},
                    ],
                    top: '0%',
                }
            ]
        };

        if (this.deviceService.isMobile()) {
            this.data.series[0].label.fontSize = 18;
        }

        this.compare = [
            {
                'lib': 'Retraités',
                'quartier': (irisData != null ? (irisData.T_retraite * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_retraite * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.carac_commune.T_retraite * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.carac_commune_fr.T_retraite * 100).toFixed(1) + ' %',
            },
            {
                'lib': 'Actifs',
                'quartier': (irisData != null ? (irisData.T_actif_occ * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_actif_occ * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.carac_commune.T_actif_occ * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.carac_commune_fr.T_actif_occ * 100).toFixed(1) + ' %',
            },
            {
                'lib': 'Inactifs',
                'quartier': (irisData != null ? (irisData.T_autre_inac * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_autre_inac * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.carac_commune.T_autre_inac * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.carac_commune_fr.T_autre_inac * 100).toFixed(1) + ' %',
            },
            {
                'lib': 'Chômeurs',
                'quartier': (irisData != null ? (irisData.T_chom * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_chom * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.carac_commune.T_chom * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.carac_commune_fr.T_chom * 100).toFixed(1) + ' %',
            },
            {
                'lib': 'Étudiants',
                'quartier': (irisData != null ? (irisData.T_etud * 100).toFixed(1) + ' %' : '-'),
                'secteur': (secteurData != null ? (secteurData.T_etud * 100).toFixed(1) + ' %' : '-'),
                'ville': (this.favorite.ad_city.carac_commune.T_etud * 100).toFixed(1) + ' %',
                'france': (this.favorite.ad_city.carac_commune_fr.T_etud * 100).toFixed(1) + ' %',
            },
        ];
    }

    edit(event, fields = '') {
        if (fields == 'secteur') {
            this.iris = this.secteur;
        }
        this.setData();
    }

    toogleTabs(t) {
        this.tabs = t;
        this.setData();
    }
}
